module.exports = __webpack_public_path__ + "static/media/question-methods.6b77a4c7.png";